import { motion } from "framer-motion";

export default function SectionHeader({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.5 }}
      className={`mb-10 sm:mb-14 ${align === "center" ? "text-center" : "text-left"}`}
    >
      {eyebrow && (
        <div className="text-[11px] uppercase tracking-[0.4em] text-[#FFBF00] mb-3">{eyebrow}</div>
      )}
      <h2 className="font-hero text-4xl sm:text-5xl md:text-6xl leading-none tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className={`text-white/60 mt-4 max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
